import React, { useEffect, useState } from 'react';
import '.././App.css';
import { auth, db } from '../firebase';
import { doc, getDoc, getDocs, collection, query, where } from 'firebase/firestore';
import { Chip, Box } from '@mui/material';

function Header() {
  const [schoolName, setSchoolName] = useState("Loading...");
  const [activeYear, setActiveYear] = useState("");

  const signOut = () => {
    auth.signOut();
    window.location.href = "/login";
  };



  return (
    <div>
      <nav
        className="main-header navbar navbar-expand navbar-orange navbar-light"
        style={{
          background: "linear-gradient(90deg, #0f5b67, #0f586a)",
          padding: "0.5rem 1rem",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
        }}
      >
        {/* Left navbar links */}
        <ul className="navbar-nav">
          {/* <li className="nav-item">
            <a className="nav-link" data-widget="pushmenu" href="#0" role="button">
              <i className="fas fa-bars" style={{ color: "#f5f5dc", fontSize: 18, marginTop: 5 }} />
            </a>
          </li> */}
          <li className="nav-item d-flex align-items-center">
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <b style={{ color: "#fdf6e3", textTransform: "uppercase", fontSize: 16 }}>
                GIS World
              </b>
              
              {/* Academic Year Badge */}
              {activeYear && (
                <Chip 
                  label={`Academic Year: ${activeYear}`} 
                  size="small" 
                  sx={{ 
                    bgcolor: 'rgba(255,255,255,0.2)', 
                    color: '#fdf6e3', 
                    fontWeight: 'bold',
                    border: '1px solid rgba(255,255,255,0.3)',
                    fontSize: '11px'
                  }} 
                />
              )}
            </Box>
          </li>
        </ul>

        {/* Right navbar links */}
        <ul className="navbar-nav ml-auto" style={{ marginLeft: "auto" }}>
          <li className="nav-item">
            <a className="nav-link" href="javascript:history.go(-1)" title="Go Back">
              <i className="fas fa-backward" style={{ color: "#fdf6e3", fontSize: 16 }} />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="javascript:history.go(+1)" title="Go Forward">
              <i className="fas fa-forward" style={{ color: "#fdf6e3", fontSize: 16 }} />
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" onClick={signOut} href="#0" title="Sign Out">
              <i className="fa fa-sign-out" style={{ color: "#fdf6e3", fontSize: 16 }} />
            </a>
          </li>
        </ul>
      </nav>

      <style>{`
        .navbar-nav .nav-link:hover {
          color: #d4af37 !important;
          transition: all 0.3s ease;
        }
        .navbar-nav .nav-item {
          margin-left: 0.5rem;
        }
        @media (max-width: 768px) {
          .main-header .navbar-nav {
            flex-wrap: wrap;
          }
        }
      `}</style>
    </div>
  );
}

export default Header;